import React, { useEffect, useState } from "react";

const useDetectElement = (ref) => {
  const [outside, setOutside] = useState(true);
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setOutside(false);
      } else {
        setOutside(true);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
  return outside;
};

export default useDetectElement;